import React, {useMemo, useRef} from "react";
import * as Yup from "yup";
import ValidateMessages from "../../../../../../core/models/static/texts/vallidate-messages";
import {makeRequired, makeValidate} from "mui-rff";
import Form from "../../../../base/form";
import Button from "../../../../base/button/button";
import {OutlinedInputForm} from "../../../../base/input/outlined_input";


const formNames = {
    postalCode: 'addPostalCode_postalCode',
}

const schema = Yup.object().shape({
    [formNames.postalCode]: Yup.string().trim().nullable().required(ValidateMessages.required),
});

const validate = makeValidate(schema);
const required = makeRequired(schema);


const UpsertFreightRegionDialogAddPostalCodeSection = ({addPostalCode, selectedPostalCodes}) => {
    /**@type {React.MutableRefObject<formApi>}*/
    const formRef = useRef();

    const initialValues = useMemo(() => ({
        [formNames.postalCode]: '',
    }), [])

    /**
     * Submits the form by calling the appropriate callback with the country value and then removes the value from the fields.
     * @param values
     * @return {Promise<void>}
     */
    const onSubmit = async (values) => {
        const postalCode = values[formNames.postalCode]?.trim()?.toUpperCase()?.replaceAll(' ', '');
        if (!selectedPostalCodes.includes(postalCode))
            addPostalCode(postalCode);
        setTimeout(() => {
            formRef.current?.change(formNames.postalCode, initialValues[formNames.postalCode]);
            formRef.current?.resetFieldState(formNames.postalCode);
        }, 300);
    }

    /**
     * Prevents the default behaviour of the enter key in the keyboard and instead submits the form.
     * @param e
     */
    const preventDefaultEnterKey = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            formRef.current.submit().then();
        }
    }

    return (
        <>
            <Form
                className={'d-flex flex-wrap w-100'}
                onSubmit={onSubmit}
                validate={validate}
                initialValues={initialValues}
                render={({form, values}) => {
                    formRef.current = form
                    return (
                        <div className={'w-100'} onKeyDown={preventDefaultEnterKey}>
                            <p className={'w-100 mb-4 text-sm'}>
                                Just include the characters that are static. For example V6E covers V6E1E4 and V6E5C2 etc.
                            </p>
                            <div className={'w-100 d-flex align-items-center'}>
                                <OutlinedInputForm
                                    name={formNames.postalCode}
                                    label={"Postal/Zip Code"}
                                    required={!!required[formNames.postalCode]}
                                    type={'text'}
                                    value={values[formNames.postalCode] ?? ''}
                                    onChange={(e) => form.change(e.target.name, e.target.value)}
                                />
                                <Button
                                    variant={'contained'}
                                    color={'primary'}
                                    type={'button'}
                                    className={'ml-3 px-5 py-2-5'}
                                    onClick={() => form.submit()}
                                >
                                    Add
                                </Button>
                            </div>
                        </div>
                    );
                }}
            />
        </>
    );
}

export default UpsertFreightRegionDialogAddPostalCodeSection;
